
import React from 'react';

const SecurityTips = () => {
  return (
    <div className="bg-blue-900/20 border border-blue-600 p-4 rounded-lg text-center">
      <h4 className="text-blue-300 font-semibold mb-2">💡 Security Tips</h4>
      <ul className="text-xs text-blue-200 space-y-1">
        <li>• Write down all credentials on paper and store offline</li>
        <li>• Never store credentials on your computer or phone</li>
        <li>• Consider storing copies in multiple secure locations</li>
        <li>• Never share your credentials with anyone</li>
        <li>• Use your recovery phrase only if you forget your password or PIN</li>
      </ul>
    </div>
  );
};

export default SecurityTips;
